import React, { memo } from 'react';
import compose from 'recompose/compose';
import PropTypes from 'prop-types';
import { CSSTransition } from 'react-transition-group';
var ExpanderContainer = function ExpanderContainer(_ref) {
  var onExit = _ref.onExit,
    opened = _ref.opened,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(CSSTransition, {
    "in": opened,
    timeout: 300,
    appear: true,
    mountOnEnter: true,
    unmountOnExit: true,
    classNames: "item",
    onExited: function onExited() {
      return onExit();
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "expander-container"
  }, children));
};
ExpanderContainer.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  onExit: PropTypes.func.isRequired,
  opened: PropTypes.bool.isRequired
};
export default compose(memo)(ExpanderContainer);